module.exports = __webpack_public_path__ + "static/logo-light-98c38e6896a8c4beb8633b8374a27566.png";